<template>
  <CustomDeleteDialog
    :dialogTitle="`تایید حذف منبع ${
      resourceDetails ? resourceDetails.title : ''
    }`"
    :dialogId="`remove-single-resource-from-language-${dialogId}`"
    okTitle="حذف"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendRemoveRequest"
  >
    <p v-if="resourceDetails">
      آیا از حذف منبع
      {{ resourceDetails.title }}
      اطمینان دارید؟
    </p>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    dialogId: {
      type: [String, Number],
      required: true,
    },
    resourceDetails: {
      type: Object,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendRemoveRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let removeResourceDetailById = new RemoveResourceDetailById(_this);
        removeResourceDetailById.setRequestParam({
          resourceDetailId: _this.resourceDetails.id,
        });

        await removeResourceDetailById.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "منابع شما با موفقیت حذف شد.",
              },
            });
            _this.$emit("refetch");
            _this.$bvModal.hide(
              `remove-single-resource-from-language-${this.dialogId}`
            );
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomDeleteDialog,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { RemoveResourceDetailById } from "@/libs/Api/Resources";
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
</script>
